import { IconButton, Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

type Props = { onClick: MouseEventHandler };

export const ForwardAction = ({ onClick }: Props) => {
  const { translate } = useLocales();

  return (
    <Tooltip title={translate('shared.tooltip.forward')}>
      <IconButton size="small" onClick={onClick}>
        <Iconify icon="tabler:arrow-forward-up" />
      </IconButton>
    </Tooltip>
  );
};
